import DeviceProps from '@magnus/react-native-device-props';

// @ts-ignore
import { request as requestBillingApi } from '@web-solutions/module-billing/api/network';

// Lazily resolve the auth base URL so that Truegate flows can override
// REACT_APP_API_BILLING_URL with REACT_APP_API_TRUEGATE_BILLING_URL via
// `auth(baseUrl)` after the paymentSystem from remote config is known.
const authDeviceId = (idfm: string, baseUrl?: string) => {
  const billingApi = requestBillingApi(baseUrl || process.env.REACT_APP_API_BILLING_URL);
  return billingApi.post('/auth/device-id', { device_id: idfm });
};

export const auth = (baseUrl?: string) =>
  DeviceProps.getIDFM()
    .then(idfm => authDeviceId(idfm, baseUrl))
